import React, { useState } from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";

import { projectSvg1, projectSvg2, projectSvg3, projectSvg4 } from "./FileSvg";

import media1 from "./../../../images/media-1.png";
import media2 from "./../../../images/media-2.png";
import media3 from "./../../../images/media-3.png";
import media4 from "./../../../images/media-4.png";

const driveBlog = [
  { title: "C", progres: "40%", subtitle1: "40", subtitle2: "99" },
  { title: "D", progres: "50%", subtitle1: "73", subtitle2: "146" },
  { title: "E", progres: "55%", subtitle1: "98", subtitle2: "199" },
  { title: "F", progres: "60%", subtitle1: "60", subtitle2: "99" },
];

const libraryList = [
  { id: 0, title: "Project 01", svgIocn: projectSvg1 },
  { id: 1, title: "Project 02", svgIocn: projectSvg1 },
  { id: 2, title: "Project 03", svgIocn: projectSvg1 },
  { id: 3, title: "Project 04", svgIocn: projectSvg1 },
  { id: 4, title: "Project 04", svgIocn: projectSvg1 },
  { id: 5, title: "list.txt", svgIocn: projectSvg2 },
  { id: 6, title: "theme.mp3", svgIocn: projectSvg3 },
  { id: 7, title: "preview.mp4", svgIocn: projectSvg4 },
  { id: 8, title: "profile.jpg", image: media1 },
  { id: 9, title: "team.jpg", image: media2 },
  { id: 10, title: "profile2.png", image: media3 },
  { id: 11, title: "profile3.png", image: media4 },
];

const FileManager = () => {
  const [toggle, setToggle] = useState();
  return (
    <>
      <div className="card p-0 rounded-0 file_area mb-0">
        <div className="row gx-0">
          <div className="col-xl-2 col-xxl-3 col-lg-3 col-md-4">
            <div
              className="email-left-box border-end  dlab-scroll"
              id="email-left"
            >
              <div className="p-0">
                <Link to={"email-compose"} className="btn text-white btn-block">
                  <i className="fa-solid fa-plus me-3"></i>Upload
                </Link>
              </div>
              <div className="mail-list rounded ">
                <Link to={"email-inbox"} className="list-group-item active">
                  <i className="fa-regular fa-envelope align-middle"></i>Inbox{" "}
                  <span className="badge badge-purple badge-sm float-end rounded">
                    2
                  </span>{" "}
                </Link>
                <Link to={"#"} className="list-group-item">
                  <i className="fa-regular fa-paper-plane align-middle"></i>Sent
                </Link>
                <Link to={"#"} className="list-group-item">
                  <i className="fa-regular fa-star align-middle"></i>Favorite{" "}
                </Link>
                <Link to={"#"} className="list-group-item">
                  <i className="fa-regular fa-file align-middle"></i>Draft
                </Link>
                <Link to={"#"} className="list-group-item ">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4425 10.0575L10.065 15.435C9.92569 15.5745 9.76026 15.6851 9.57816 15.7606C9.39606 15.8361
                                        9.20087 15.8749 9.00375 15.8749C8.80663 15.8749 8.61144 15.8361 8.42934 15.7606C8.24724 15.6851 8.08181 15.5745 7.9425 15.435L1.5 9V1.5H9L15.4425
                                        7.9425C15.7219 8.22354 15.8787 8.60372 15.8787 9C15.8787 9.39628 15.7219 9.77646 15.4425 10.0575Z"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.25 5.25H5.268"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Important
                </Link>
                <Link to={"#"} className="list-group-item">
                  <i className="fa-regular fa-clock align-middle"></i> Scheduled
                </Link>

                <Link to={"#"} className="list-group-item">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 8.25L11 13.75L16.5 8.25"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Move
                </Link>
              </div>
              <div className="mail-list rounded overflow-hidden mt-4">
                <div className="intro-title d-flex justify-content-between my-0">
                  <h5>Categories</h5>
                </div>
                <Link to={"email-inbox"} className="list-group-item change">
                  Work{" "}
                </Link>
                <Link to={"email-inbox"} className="list-group-item change">
                  Private{" "}
                </Link>
                <Link to={"email-inbox"} className="list-group-item change">
                  Support{" "}
                </Link>
                <Link to={"email-inbox"} className="list-group-item change">
                  Social{" "}
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-10 col-xxl-9 col-lg-9 col-md-8">
            <div className="row  gx-0">
              <div className="col-xl-12">
                <div className="file-drive">
                  <div className="card-body p-3">
                    <div className="row gx-0">
                      {driveBlog.map((item, index) => (
                        <div className="col-xl-3 col-sm-6" key={index}>
                          <div className="drive">
                            <div className="dz-folder">
                              <svg
                                width="79"
                                height="62"
                                viewBox="0 0 79 62"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  opacity="0.7"
                                  d="M75.1668 20.5H68.3334V13.6667C68.3343 12.9934 68.2024 12.3266 67.9451 11.7044C67.6879 11.0822 67.3104 10.5168 66.8343 10.0407C66.3583 9.56467 65.7929 9.1872 65.1707 8.92996C64.5485 8.67272 63.8817 8.54078 63.2084 8.54168H37.1563C36.3935 8.54184 35.6403 8.37168 34.9517 8.04362C34.2631 7.71556 33.6564 7.23787 33.1759 6.64543L29.8276 2.52834C29.1893 1.73859 28.3825 1.10165 27.4661 0.664169C26.5498 0.226689 25.5472 -0.000241404 24.5317 4.56815e-06H5.12506C4.45179 -0.000894936 3.78495 0.131054 3.16275 0.38829C2.54055 0.645527 1.97521 1.023 1.49913 1.49908C1.02305 1.97516 0.645583 2.54049 0.388346 3.16269C0.131109 3.78489 -0.000838865 4.45173 6.06388e-05 5.12501V55.6404C-0.00347238 56.4099 0.147413 57.1723 0.443784 57.8824C0.740155 58.5925 1.17599 59.236 1.72548 59.7746C2.26414 60.3241 2.90758 60.7599 3.6177 61.0563C4.32781 61.3527 5.09017 61.5036 5.85965 61.5H63.3622C64.6314 61.4996 65.8665 61.0884 66.8827 60.3278C67.8988 59.5672 68.6415 58.4981 68.9997 57.2804L78.4468 24.8734C78.5942 24.3642 78.6213 23.8278 78.5259 23.3063C78.4306 22.7849 78.2154 22.2928 77.8974 21.8687C77.5793 21.4447 77.1671 21.1003 76.6933 20.8628C76.2194 20.6253 75.6968 20.5011 75.1668 20.5Z"
                                  fill="#01A3FF"
                                />
                                <path
                                  d="M75.1645 20.5H26.6031C25.3352 20.5002 24.1016 20.9115 23.0875 21.6723C22.0733 22.4332 21.3332 23.5024 20.9784 24.7196L11.48 57.2828C11.1252 58.4994 10.3853 59.5681 9.3715 60.3285C8.35766 61.0889 7.12455 61.5 5.85724 61.5H63.3662C64.6343 61.5001 65.8682 61.0889 66.8826 60.3281C67.8971 59.5672 68.6374 58.4978 68.9923 57.2804L78.4446 24.8733C78.5932 24.3641 78.6211 23.8273 78.5262 23.3054C78.4313 22.7836 78.2162 22.2909 77.8979 21.8666C77.5797 21.4423 77.167 21.0979 76.6925 20.8607C76.2181 20.6235 75.6949 20.5 75.1645 20.5Z"
                                  fill="#01A3FF"
                                />
                              </svg>
                            </div>
                            <div className="drive-content">
                              <h4 className="title">{item.title} Drive </h4>
                              <div className="progress default-progress">
                                <div
                                  className="progress-bar bg-vigit progress-animated bg-primary"
                                  style={{
                                    width: item.progres,
                                    height: "100%",
                                  }}
                                  role="progressbar"
                                >
                                  <span className="sr-only">
                                    {item.progres} Complete
                                  </span>
                                </div>
                              </div>
                              <span>
                                {item.subtitle1} GB / {item.subtitle2} GB
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12">
                <div className="file-header">
                  <div className="card-body py-0">
                    <div className="page-titles">
                      <div className="my-2">
                        <h2 className="heading">Recent Files</h2>
                        <div className="file-path">
                          <div className="me-2">
                            <svg
                              width="20"
                              height="16"
                              viewBox="0 0 20 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.9833 6.64169C18.9049 6.545 18.8058 6.46712 18.6933 6.41376C18.5808 6.36041 18.4578 6.33293 18.3333 6.33335H16.6666V5.50002C16.6666 4.83698 16.4033 4.20109 15.9344 3.73225C15.4656 3.26341 14.8297 3.00002 14.1666 3.00002H8.93331L8.66665 2.16669C8.49377 1.67771 8.1731 1.2546 7.74906 0.955986C7.32502 0.657367 6.81861 0.498019 6.29998 0.500019H3.33331C2.67027 0.500019 2.03439 0.763411 1.56555 1.23225C1.09671 1.70109 0.833313 2.33698 0.833313 3.00002V13C0.833313 13.6631 1.09671 14.2989 1.56555 14.7678C2.03439 15.2366 2.67027 15.5 3.33331 15.5H15.3333C15.901 15.4984 16.4512 15.3036 16.8935 14.9476C17.3357 14.5917 17.6437 14.0959 17.7666 13.5417L19.1666 7.35002C19.192 7.22578 19.1886 7.0974 19.1569 6.97466C19.1251 6.85191 19.0657 6.73803 18.9833 6.64169ZM4.47498 13.1834C4.43264 13.3713 4.32647 13.5388 4.17453 13.6574C4.02259 13.7759 3.83428 13.8381 3.64165 13.8334H3.33331C3.1123 13.8334 2.90034 13.7456 2.74406 13.5893C2.58778 13.433 2.49998 13.221 2.49998 13V3.00002C2.49998 2.779 2.58778 2.56704 2.74406 2.41076C2.90034 2.25448 3.1123 2.16669 3.33331 2.16669H6.29998C6.4817 2.1572 6.66153 2.20746 6.81201 2.30978C6.96248 2.4121 7.07533 2.56087 7.13331 2.73335L7.58331 4.10002C7.63679 4.25897 7.73698 4.39809 7.87079 4.49919C8.0046 4.60029 8.1658 4.65867 8.33331 4.66669H14.1666C14.3877 4.66669 14.5996 4.75448 14.7559 4.91076C14.9122 5.06704 15 5.27901 15 5.50002V6.33335H6.66665C6.47401 6.32864 6.2857 6.39084 6.13376 6.50935C5.98182 6.62786 5.87565 6.79537 5.83331 6.98335L4.47498 13.1834ZM16.1416 13.1834C16.0993 13.3713 15.9931 13.5388 15.8412 13.6574C15.6893 13.7759 15.5009 13.8381 15.3083 13.8334H6.00831C6.05135 13.7405 6.08216 13.6425 6.09998 13.5417L7.33331 8.00002H17.3333L16.1416 13.1834Z"
                                fill="#01A3FF"
                              />
                            </svg>
                          </div>
                          <h4>
                            <Link to={"#"}>All File /</Link>
                            <Link to={"#"}>Folder /</Link>
                            <Link to={"#"}>Library</Link>
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex my-2">
                        <div className="input-group search-area">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search here..."
                          />
                          <span className="input-group-text">
                            <Link to={"#"}>
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  opacity="0.3"
                                  d="M16.6751 19.4916C16.2194 19.036 16.2194 18.2973 16.6751 17.8417C17.1307 17.3861 17.8694 17.3861 18.325 17.8417L22.9916 22.5084C23.4473 22.964 23.4473 23.7027 22.9916 24.1583C22.536 24.6139 21.7973 24.6139 21.3417 24.1583L16.6751 19.4916Z"
                                  fill="white"
                                />
                                <path
                                  d="M12.8333 18.6667C16.055 18.6667 18.6667 16.055 18.6667 12.8334C18.6667 9.61169 16.055 7.00002 12.8333 7.00002C9.61166 7.00002 6.99999 9.61169 6.99999 12.8334C6.99999 16.055 9.61166 18.6667 12.8333 18.6667ZM12.8333 21C8.323 21 4.66666 17.3437 4.66666 12.8334C4.66666 8.32303 8.323 4.66669 12.8333 4.66669C17.3436 4.66669 21 8.32303 21 12.8334C21 17.3437 17.3436 21 12.8333 21Z"
                                  fill="white"
                                />
                              </svg>
                            </Link>
                          </span>
                        </div>
                        <div
                          className={`d-flex align-items-center folder-layout-tab ${
                            toggle ? "grid" : ""
                          } `}
                        >
                          <div
                            className="feature-btn"
                            onClick={() => setToggle(!toggle)}
                          >
                            <svg
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m7.1971 7.5684h-1.8203-2.8809c-0.23438 0-0.47852 0.01953-0.71289-0.00586 0.06836 0.00977 0.13867 0.01953 0.20703 0.02734-0.0625-0.00976-0.11914-0.02343-0.17774-0.04687 0.0625 0.02539 0.125 0.05273 0.1875 0.07812-0.05468-0.02539-0.10547-0.05468-0.15429-0.09179 0.05273 0.04101 0.10547 0.08203 0.1582 0.12304-0.03906-0.0332-0.07422-0.06836-0.10742-0.10742 0.04101 0.05274 0.08203 0.10547 0.12304 0.1582-0.0371-0.04882-0.0664-0.09765-0.09179-0.15429 0.02539 0.0625 0.05273 0.125 0.07812 0.1875-0.02343-0.0586-0.03906-0.11524-0.04687-0.17774 0.00976 0.06836 0.01953 0.13868 0.02734 0.20703-0.01953-0.19335-0.00586-0.39257-0.00586-0.58593v-1.2871-2.9082c0-0.23438-0.01953-0.47852 0.00586-0.7129-0.00976 0.06836-0.01953 0.13868-0.02734 0.20704 0.00976-0.0625 0.02344-0.11914 0.04687-0.17774-0.02539 0.0625-0.05273 0.125-0.07812 0.1875 0.02539-0.05469 0.05469-0.10547 0.09179-0.1543-0.04101 0.05274-0.08203 0.10547-0.12304 0.15821 0.0332-0.03907 0.06836-0.07422 0.10742-0.10742-0.05273 0.04101-0.10547 0.08203-0.1582 0.12304 0.04882-0.03711 0.09765-0.0664 0.15429-0.09179-0.0625 0.02539-0.125 0.05273-0.1875 0.07812 0.0586-0.02344 0.11524-0.03906 0.17774-0.04687-0.06836 0.00976-0.13867 0.01953-0.20703 0.02734 0.19336-0.01953 0.39257-0.00586 0.58593-0.00586h1.2871 2.9082c0.23437 0 0.47851-0.01953 0.71289 0.00586-0.06836-0.00977-0.13867-0.01953-0.20703-0.02734 0.0625 0.00976 0.11914 0.02343 0.17773 0.04687-0.0625-0.02539-0.125-0.05273-0.1875-0.07812 0.05469 0.02539 0.10547 0.05468 0.1543 0.09179-0.05274-0.04101-0.10547-0.08203-0.15821-0.12304 0.03907 0.0332 0.07422 0.06835 0.10743 0.10742-0.04102-0.05274-0.08203-0.10547-0.12305-0.15821 0.03711 0.04883 0.06641 0.09766 0.0918 0.1543-0.02539-0.0625-0.05274-0.125-0.07813-0.1875 0.02344 0.0586 0.03906 0.11524 0.04688 0.17774-0.00977-0.06836-0.01953-0.13868-0.02735-0.20704 0.01953 0.19336 0.00586 0.39258 0.00586 0.58594v1.2871 2.9082c0 0.23438 0.01953 0.47852-0.00586 0.71289 0.00977-0.06835 0.01953-0.13867 0.02735-0.20703-0.00977 0.0625-0.02344 0.11914-0.04688 0.17774 0.02539-0.0625 0.05274-0.125 0.07813-0.1875-0.02539 0.05469-0.05469 0.10547-0.0918 0.15429 0.04102-0.05273 0.08203-0.10546 0.12305-0.1582-0.03321 0.03906-0.06836 0.07422-0.10743 0.10742 0.05274-0.04101 0.10547-0.08203 0.15821-0.12304-0.04883 0.03711-0.09766 0.0664-0.1543 0.09179 0.0625-0.02539 0.125-0.05273 0.1875-0.07812-0.05859 0.02344-0.11523 0.03906-0.17773 0.04687 0.06836-0.00976 0.13867-0.01953 0.20703-0.02734-0.02539 0.00391-0.05274 0.00586-0.08008 0.00586-0.20312 0.00391-0.4082 0.08398-0.55273 0.22852-0.13477 0.13476-0.23829 0.35742-0.22852 0.55273 0.01953 0.41601 0.34375 0.79101 0.78125 0.78125 0.38281-0.00781 0.75-0.15039 1.0215-0.42383 0.26563-0.26562 0.40626-0.62109 0.42188-0.99414 0.00195-0.06445 0-0.12695 0-0.19141v-1.1387-3.2402c0-0.25977 0.00391-0.51953 0-0.7793-0.00781-0.53125-0.29883-1.0684-0.79297-1.2969-0.21875-0.10157-0.41601-0.15625-0.66211-0.15821h-0.08594-2.6777-2.5176c-0.39453 0-0.78125 0.14063-1.0625 0.42383-0.2832 0.2832-0.42383 0.66797-0.42383 1.0664v0.91601 3.252 1.0273 0.08398c0.001953 0.24415 0.058594 0.44532 0.1582 0.66211 0.22852 0.49414 0.76562 0.78516 1.2969 0.79297 0.78125 0.00977 1.5625 0 2.3438 0h2.8144 0.16407c0.4082 0 0.80078-0.35937 0.78125-0.78125-0.01563-0.42578-0.33985-0.7832-0.7793-0.7832zm0 3.3007h-2.1426-2.9414c-0.08007 0-0.16015-0.0019-0.24023 0-0.63281 0.0098-1.1641 0.4004-1.377 0.9922-0.10742 0.2969-0.076172 0.6524-0.076172 0.9649v3.1386 1.334 0.3125c0 0.4063 0.15234 0.8184 0.46094 1.0938 0.29102 0.2597 0.64453 0.3887 1.0332 0.3887h0.34375 1.3555 3.1152 0.38281c0.27735 0 0.53711-0.0508 0.78711-0.1817 0.4668-0.2422 0.74219-0.7617 0.7461-1.2773v-0.2676-2.9668-1.4805c0-0.2265 0.01562-0.4609-0.00586-0.6875-0.03125-0.3594-0.16602-0.709-0.4375-0.959-0.27735-0.2558-0.62305-0.3964-1.0039-0.4043-0.4082-0.0078-0.80078 0.3653-0.78125 0.7813 0.01953 0.4297 0.34375 0.7715 0.78125 0.7812 0.02734 0 0.05469 2e-3 0.08203 0.0059-0.06836-0.0098-0.13867-0.0195-0.20703-0.0273 0.0625 0.0097 0.11914 0.0234 0.17773 0.0468-0.0625-0.0254-0.125-0.0527-0.1875-0.0781 0.05469 0.0254 0.10547 0.0547 0.1543 0.0918-0.05273-0.041-0.10547-0.082-0.1582-0.123 0.03906 0.0332 0.07422 0.0683 0.10742 0.1074-0.04102-0.0528-0.08203-0.1055-0.12305-0.1582 0.03711 0.0488 0.06641 0.0976 0.0918 0.1543-0.02539-0.0625-0.05273-0.125-0.07813-0.1875 0.02344 0.0586 0.03907 0.1152 0.04688 0.1777-0.00977-0.0684-0.01953-0.1387-0.02734-0.207 0.01953 0.1933 0.00586 0.3926 0.00586 0.5859v1.2871 2.9082c0 0.2344 0.01953 0.4785-0.00586 0.7129 0.00976-0.0683 0.01953-0.1387 0.02734-0.207-0.00977 0.0625-0.02344 0.1191-0.04688 0.1777 0.0254-0.0625 0.05274-0.125 0.07813-0.1875-0.02539 0.0547-0.05469 0.1055-0.0918 0.1543 0.04102-0.0527 0.08203-0.1055 0.12305-0.1582-0.0332 0.0391-0.06836 0.0742-0.10742 0.1074 0.05273-0.041 0.10547-0.082 0.1582-0.123-0.04883 0.0371-0.09765 0.0664-0.1543 0.0918 0.0625-0.0254 0.125-0.0528 0.1875-0.0781-0.05859 0.0234-0.11523 0.039-0.17773 0.0468 0.06836-0.0097 0.13867-0.0195 0.20703-0.0273-0.19336 0.0195-0.39258 0.0058-0.58594 0.0058h-1.2871-2.9082c-0.23437 0-0.47852 0.0196-0.71289-0.0058 0.06836 0.0098 0.13867 0.0195 0.20703 0.0273-0.0625-0.0097-0.11914-0.0234-0.17773-0.0468 0.0625 0.0253 0.125 0.0527 0.1875 0.0781-0.05469-0.0254-0.10547-0.0547-0.1543-0.0918 0.05273 0.041 0.10547 0.082 0.1582 0.123-0.03906-0.0332-0.07422-0.0683-0.10742-0.1074 0.04102 0.0527 0.08203 0.1055 0.12305 0.1582-0.03711-0.0488-0.06641-0.0976-0.0918-0.1543 0.02539 0.0625 0.05274 0.125 0.07813 0.1875-0.02344-0.0586-0.03907-0.1152-0.04688-0.1777 0.00977 0.0683 0.01953 0.1387 0.02734 0.207-0.01953-0.1933-0.00585-0.3926-0.00585-0.5859v-1.2871-2.9082c0-0.2344-0.01954-0.4785 0.00585-0.7129-0.00976 0.0683-0.01953 0.1386-0.02734 0.207 0.00977-0.0625 0.02344-0.1191 0.04688-0.1777-0.02539 0.0625-0.05274 0.125-0.07813 0.1875 0.02539-0.0547 0.05469-0.1055 0.0918-0.1543-0.04102 0.0527-0.08203 0.1054-0.12305 0.1582 0.0332-0.0391 0.06836-0.0742 0.10742-0.1074-0.05273 0.041-0.10547 0.082-0.1582 0.123 0.04883-0.0371 0.09766-0.0664 0.1543-0.0918-0.0625 0.0254-0.125 0.0527-0.1875 0.0781 0.05859-0.0234 0.11523-0.039 0.17773-0.0468-0.06836 0.0097-0.13867 0.0195-0.20703 0.0273 0.19336-0.0195 0.39258-0.0059 0.58594-0.0059h1.2598 2.8965 0.67187c0.40821 0 0.80079-0.3593 0.78125-0.7812-0.01953-0.4238-0.34375-0.7813-0.7832-0.7813zm3.5039-6.8691h0.8066 1.9356 2.332 2.0254c0.3281 0 0.6563 0.00586 0.9844 0h0.0137c0.4082 0 0.8007-0.35938 0.7812-0.78125-0.0195-0.42383-0.3437-0.78125-0.7812-0.78125h-0.8067-1.9355-2.3321-2.0253c-0.3282 0-0.6563-0.00586-0.9844 0h-0.0137c-0.4082 0-0.80077 0.35938-0.78124 0.78125 0.01758 0.42187 0.34374 0.78125 0.78124 0.78125zm5.0313 2.0391h-1.7012-2.711-0.621c-0.4082 0-0.80083 0.35938-0.7813 0.78125 0.01954 0.42383 0.3438 0.78125 0.7813 0.78125h1.7011 2.711 0.6211c0.4082 0 0.8007-0.35937 0.7812-0.78125-0.0176-0.42383-0.3418-0.78125-0.7812-0.78125zm-5.0313 7.9218h0.8066 1.9356 2.332 2.0254c0.3281 0 0.6563 0.0059 0.9844 0h0.0137c0.4082 0 0.8007-0.3593 0.7812-0.7812-0.0195-0.4238-0.3437-0.7813-0.7812-0.7813h-0.8067-1.9355-2.3321-2.0253c-0.3282 0-0.6563-0.0058-0.9844 0h-0.0137c-0.4082 0-0.80077 0.3594-0.78124 0.7813 0.01758 0.4238 0.34374 0.7812 0.78124 0.7812zm5.0313 2.0391h-1.7012-2.711-0.621c-0.4082 0-0.80083 0.3594-0.7813 0.7812 0.01954 0.4239 0.3438 0.7813 0.7813 0.7813h1.7011 2.711 0.6211c0.4082 0 0.8007-0.3594 0.7812-0.7813-0.0176-0.4218-0.3418-0.7812-0.7812-0.7812z"
                                fill="#01A3FF"
                              />
                            </svg>
                          </div>
                          <div
                            className="feature-btn"
                            onClick={() => setToggle(!toggle)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V9C3 9.53043 3.21071 10.0391 3.58579 10.4142C3.96086 10.7893 4.46957 11 5 11H9C9.53043 11 10.0391 10.7893 10.4142 10.4142C10.7893 10.0391 11 9.53043 11 9V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3ZM5 9V5H9V9H5ZM19 3H15C14.4696 3 13.9609 3.21071 13.5858 3.58579C13.2107 3.96086 13 4.46957 13 5V9C13 9.53043 13.2107 10.0391 13.5858 10.4142C13.9609 10.7893 14.4696 11 15 11H19C19.5304 11 20.0391 10.7893 20.4142 10.4142C20.7893 10.0391 21 9.53043 21 9V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3ZM15 9V5H19V9H15ZM9 13H5C4.46957 13 3.96086 13.2107 3.58579 13.5858C3.21071 13.9609 3 14.4696 3 15V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H9C9.53043 21 10.0391 20.7893 10.4142 20.4142C10.7893 20.0391 11 19.5304 11 19V15C11 14.4696 10.7893 13.9609 10.4142 13.5858C10.0391 13.2107 9.53043 13 9 13ZM5 19V15H9V19H5ZM19 13H15C14.4696 13 13.9609 13.2107 13.5858 13.5858C13.2107 13.9609 13 14.4696 13 15V19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15C21 14.4696 20.7893 13.9609 20.4142 13.5858C20.0391 13.2107 19.5304 13 19 13ZM15 19V15H19V19H15Z"
                                fill="#01A3FF"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <PerfectScrollbar
                  as="ul"
                  className={`folder-structure dlab-scroll ${
                    toggle ? "grid" : ""
                  }`}
                >
                  {libraryList.map((data, ind) => (
                    <li key={ind}>
                      <div className="file-list">
                        <div className="dz-media">
                          {data.id <= 7 ? (
                            data.svgIocn
                          ) : (
                            <img className="dz-img" src={data.image} alt="" />
                          )}
                        </div>
                        <div className="dz-info">
                          <Link to={"#"}>
                            <h4 className="title">{data.title}</h4>
                            <span>
                              3 Items December 27th, 2021 04:56 AM - 10.0 MB
                            </span>
                          </Link>
                        </div>
                      </div>
                    </li>
                  ))}
                </PerfectScrollbar>
              </div>
              <div className="col-xl-12">
                <div className="table-pagenation">
                  <p>
                    Showing <span>1-5</span>from <span>100</span>data
                  </p>
                  <nav>
                    <ul className="pagination pagination-gutter pagination-primary no-bg">
                      <li className="page-item page-indicator">
                        <Link to={"#"} className="page-link">
                          <i className="fa-solid fa-angle-left"></i>
                        </Link>
                      </li>
                      <li className="page-item ">
                        <Link to={"#"} className="page-link">
                          1
                        </Link>
                      </li>
                      <li className="page-item active">
                        <Link to={"#"} className="page-link">
                          2
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link to={"#"} className="page-link">
                          3
                        </Link>
                      </li>
                      <li className="page-item page-indicator">
                        <Link to={"#"} className="page-link">
                          <i className="fa-solid fa-angle-right"></i>
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FileManager;
